module.exports = __webpack_public_path__ + "img/a4.948f616b.webp";